<template>
  <div class="im-ai-robot-assistant-container">
    <div class="im-ai-robot-assistant" @click="handleShowAiRobot">
      <img :src="aiLogo" alt="" srcset="" />
    </div>
    <yxtbiz-ai-assistant
      :visible.sync="showAiRobot"
      :publicResourceEnabled="publicResourceEnabled"
    ></yxtbiz-ai-assistant>
    <!-- <yxtbiz-ai-robot v-if="showAiRobot" @close="close" mode="student"></yxtbiz-ai-robot> -->
  </div>
</template>
<script>
import { staticBaseUrl } from '@IM/conost'
import { GetAiLogo, GetIsShowAiEntry } from '@IM/service/main.service'
export default {
  data() {
    return {
      showAiRobot: false,
      staticBaseUrl,
      aiLogo: '',
      publicResourceEnabled: 0
    }
  },
  mounted() {
    if (localStorage.getItem('aiLogoUrl')) {
      this.aiLogo = localStorage.getItem('aiLogoUrl')
    } else {
      GetAiLogo().then((res) => {
        this.aiLogo = res.aiLogoUrl
      })
    }
  },
  watch: {
    showAiRobot(newVal) {
      if (newVal) {
        this.$emit('changeIndex', 999)
      } else {
        this.$emit('changeIndex', 1000)
      }
    }
  },
  methods: {
    handleShowAiRobot() {
      GetIsShowAiEntry().then((res) => {
        if (res) {
          this.showAiRobot = true
          this.publicResourceEnabled = res.publicResourceEnabled
          // this.$emit('changeIndex', 1000)
        } else {
          this.$message.warning(
            this.$t('pc_biz_no_open_aiSetting').d('暂未开启企业AI助手服务')
          )
        }
      })
      // this.showAiRobot = true
      // this.$emit('changeIndex', 1000)
    },
    close() {
      this.showAiRobot = false
    }
  }
}
</script>
<style lang="scss" scoped>
.im-add-xxx {
  width: 300px;
  height: 300px;
  right: 10px;
  bottom: 10px;
  background-color: aquamarine;
}
// 重置容器内所有div的text-align，避免父级样式影响
.im-ai-robot-assistant-container {
  div {
    text-align: initial; // 重置text-align为初始值
  }
}

.im-ai-robot-assistant {
  height: 56px;
  width: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: initial; // 确保按钮本身不受父级text-align影响
  > img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
}
</style>
